export enum ChestTypeEnum {
  MISSION = 'MISSION',
  RANK = 'RANK',
  LEVEL = 'LEVEL',
}
